// extracted by mini-css-extract-plugin
export default {"globalSpin":"Spinner_globalSpin__JOpIG","globalSpinIcon":"Spinner_globalSpinIcon__MZ4rw","globalSpinText":"Spinner_globalSpinText__hlv+0"};